import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import { closeIcon } from "assets/icons/importIcon";
import { Button, CircularProgress } from "@material-ui/core";
import Step1 from './Step1';
import Step2 from './Step2';
import StepDot from "components/Base/StepDot";
import { isString } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { createExercise } from "actions/exercise";
import AppHelper from "helpers/AppHelper";
import { getListSection } from "actions/brik";
import { alertActions } from 'actions/alert.actions';

const CreateExercise = React.forwardRef((props: any, ref: any) => {
  const { loadCreate, dataCreate } = useSelector((state: any) => state.exercise);
  const classes = useStyles();
  const [index, setIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [name, setName] = useState('');
  const [difficulty, setDifficulty] = useState(0);
  const [description, setDescription] = useState<any>('');
  const [url, setUrl] = useState<any>('');
  const [file, setFile] = useState<any>(null);
  const [thumbNail, setThumbnail] = useState<any>(null);
  const [errorName, setErrorName] = useState(false);
  const [errorDescription, setErrorDescription] = useState(false);
  const dispatch = useDispatch();
  const pages = [
    { subTitle: 'Enter in the below info to create a new exercise.' },
    { subTitle: 'Upload a gif or video.' },
  ]

  const { isEdit, itemEdit, isCreate, brikId, subId, sectionId, lastContentOrder, isDuplicate } = props;

  useEffect(() => {
    if (isEdit || isDuplicate) {
      setName(itemEdit?.name);
      setDescription(itemEdit?.description);
      setDifficulty(itemEdit?.difficulty ? itemEdit?.difficulty : 0);
      setUrl(itemEdit?.url);
      setFile(itemEdit?.file || null);
      setThumbnail(itemEdit?.videoThumbnail);
    } else {
      setName('');
      setDescription('');
      setDifficulty(0);
      setUrl('');
      setFile(null);
      setThumbnail(null);
    }
  }, [itemEdit, isEdit]);

  const onHandleCloseModal = () => {
    AppHelper.hideGlobalModal();
    if (!isEdit && !isCreate && !isDuplicate) {
      AppHelper.showListExercises({ brikId, sectionId, subId, lastContentOrder });
    }
    setIndex(0);
    setName('');
    setDescription('');
  };

  const onBackClick = () => {
    if (index > 0) {
      setPrevIndex(index);
      setIndex(index - 1);
    }
  };

  const handleValite = () => {
    if (name.trim() === '') {
      setErrorName(true)
    } else {
      setErrorName(false)
    }
  }

  const onNextClick = () => {
    handleValite();
    if (name.trim() === '') return
    if (index < pages.length - 1) {
      setPrevIndex(index);
      setIndex(index + 1);
    }
  };

  const onFinishClick = async () => {
    let params = {
      name,
      description,
      url,
      file: file,
      difficulty,
      thumbNail
    }
    if (isString(file)) {
      params.file =  file.includes("https") ? file.replace(process.env.REACT_APP_STORAGE_DOMAIN, "") : file;
    };
    // if (!url && !file) {
    //   dispatch(alertActions.error('You must enter image, gif or video !'));
    //   return
    // }
    if (
      url &&
      !url.includes('https://www.youtube.com') &&
      !url.includes('https://youtu.be') &&
      !url.includes('https://vimeo.com')
    ) {
      dispatch(alertActions.error('Only support Youtube or Vimeo Url'));
      return
    }

    if (isEdit) {
      await dispatch(createExercise(params, itemEdit?.id));
      // if (!file) {
      //   dispatch(deleteImageExercise(itemEdit?.id));
      // }
      if (brikId) {
        await dispatch(getListSection(brikId))
      }
    } else {
      await dispatch(createExercise(params))
    }
    onHandleCloseModal();
  };

  const onChangeStep1 = (value: any, type: any) => {
    if (type === 'name') {
      setName(value);
      if (value.trim() !== '') return setErrorName(false)
      setErrorName(true)
    } else if (type === 'difficulty') {
      setDifficulty(value);
    } else {
      setDescription(value);
    }
  }

  useEffect(() => {
    if(dataCreate?.success){
      onHandleCloseModal();
    }
  }, [dataCreate]);

  const renderContent = () => {
    switch (index) {
      case 0:
        return <Step1 name={name} description={description} difficulty={difficulty} onChange={onChangeStep1} errorName={errorName} />;
      case 1:
        return <Step2 
          urlVideoExercise={url}
          setUrlVideoExercise={setUrl}
          exerciseImage={file}
          itemEdit={itemEdit}
          thumbNail={thumbNail}
          setThumbnail={setThumbnail}
          setExerciseImage={(file:any, thumbNail: any) => {
            setFile(file);
            setThumbnail(thumbNail);
          }} />;
    }
  };

  return (
    <div className={classes.container}>
      <div
        className={classes.headerModal}
        style={{ boxShadow: "1px 1px 6px rgba(56, 25, 81, 0.25)" }}
      >
        <div className={classes.titleModal}>
          <p>{isEdit ? `Editing ${itemEdit?.name}` : isDuplicate ? `Duplicate ${itemEdit?.name}` : 'Create a new exercise'}</p>
          <p>{isEdit ? '' : pages[index]?.subTitle}</p>
        </div>
        <StepDot
          prevDot={prevIndex}
          totalDot={pages.length}
          selectDot={index}
          withoutLine={true}
          customClass={classes.customDot}
        />
        <div>
          <div style={{ display: "flex", justifyContent: "flex-end", cursor: 'pointer' }}>
            <img src={closeIcon} alt="" onClick={onHandleCloseModal} />
          </div>
        </div>
      </div>
      <div className={classes.bodyModalList}>
        {renderContent()}
      </div>
      <div className={classes.footerModal}>
        <div onClick={onHandleCloseModal} style={{ color: '#000' }}>Cancel</div>
        {index > 0 &&
          <div className={classes.buttonBack}>
            <Button variant="contained" onClick={onBackClick}>
              Back
            </Button>
          </div>
        }
        <div
          className={classes.btnAddRecipeBody}
        >
          {index < pages.length - 1 ?
            <Button variant="contained" onClick={onNextClick}>Next</Button> :
            <Button
              variant="contained"
              onClick={onFinishClick}
              disabled={loadCreate}
            >
              {isEdit ? `Save` : `Create`}
              {loadCreate && (
                <span className={classes.iconLoading}>
                  <CircularProgress size={16} />
                </span>
              )}
            </Button>}
        </div>
      </div>
    </div>
  );
});

export default CreateExercise;
